import {Theme, ThemeProvider} from '@mui/material';
import {Localization} from '@mui/material/locale';
import React, {useEffect, useMemo, useState} from 'react';
import {useIntl} from 'react-intl';
import {DateUtils} from 'src/js/common/utils/date_utils';
import {I18N_REDUCER_STATE_ID} from 'src/js/containers/i18n/i18n_constants';
import {useAppSelector} from 'src/js/store_hooks';

interface OwnProps {
  theme: Theme;
  dlMuiCreateThemeFunction: (theme: Theme, localeData: Localization) => Theme;
}

type Props = OwnProps;

export const DlMuiThemeProvider: React.FC<Props> = (props) => {
  const {theme, dlMuiCreateThemeFunction, children} = props;
  const [localeMuiTexts, setLocaleMuiTexts] =
    useState<Record<string, Localization>>();
  const intl = useIntl();
  const muiLocale = DateUtils.translateLocaleToMuiLocale(intl.locale);
  const i18nConfig = useAppSelector(
    (state) => state[I18N_REDUCER_STATE_ID].i18nConfig
  );

  useEffect(() => {
    if (i18nConfig) {
      const loadedMuiLocaleTexts = DateUtils.loadMuiLocaleText(i18nConfig);
      setLocaleMuiTexts(loadedMuiLocaleTexts);
    }
  }, [i18nConfig]);

  const localeData = useMemo(() => {
    return {...(localeMuiTexts?.[muiLocale] ? localeMuiTexts[muiLocale] : {})};
  }, [localeMuiTexts, muiLocale]);

  const themeWithLocale = React.useMemo(
    () => dlMuiCreateThemeFunction(theme, localeData),
    [dlMuiCreateThemeFunction, localeData, theme]
  );

  return <ThemeProvider theme={themeWithLocale}>{children}</ThemeProvider>;
};
